<template>
    <div style="margin-top:90px" v-if="session !== null">
        <div class="text-center">
            <button class="btn btn-primary" @click="openmodalproject">{{language==='English'?'Create Project':'Crear Proyecto'}}</button>
        </div>
        <v-layout>
            <v-dialog v-model="modalcreateproject" style="z-index:1000" max-width="550" persistent>
                <button type="button" class="close" @click="modalcreateproject = false">
					<span style="color:black;font-size:30px" aria-hidden="true">&times;</span>
				</button>
                <v-container style="background:white" grid-list-xs text-xs-center >
                        <v-layout justify-center style="margin-bottom:20px"> 
                            <h2 class="font-weight-bold" >{{language==='English'?!isEdit?'Create Project':'Edit Project':!isEdit?'Crear Proyecto':'Editar Proyecto'}}</h2>
                        </v-layout>
                    <form @submit.prevent="createproject">
                            <v-layout row >
                                <v-flex>
                                    <div style="margin-bottom:20px">
                                        <input class="form-control" @keyup="comadelete" :placeholder="language==='English'?`Project's name`:'Nombre del Proyecto'" v-model="projects.name"  required/>
                                    </div>
                                    <div style="margin-bottom:20px">
                                        <textarea class="form-control" :placeholder="language === 'English'?'Project description':'Descripción del Proyecto'" v-model="projects.description"   required>
                                        </textarea>  
                                    </div>
                                    <div style="margin-bottom:20px">
                                        <select v-model="projects.type" class="form-control">
                                            <option value="unselected" checked disabled>{{language === 'English'?'Choose the type of project or portfolio':'Elija el tipo de Proyecto o Portafolio'}}</option>
                                            <option value="Portafolio">{{language ==='English'?'Portfolio':'Portafolio'}}</option>
                                            <option value="General">General</option>
                                        </select>  
                                    </div>
                                    <div style="margin-bottom:20px">
                                        <select class="form-control"  v-model="projects.visible"   required>
                                            <option value="selected" disabled selected>{{language ==='English'?'Privacy':'Privacidad'}}</option>
                                            <option value="public">{{language ==='English'?'Public':'Público'}}</option>
                                            <option value="private">{{language ==='English'?'Private':'Privado'}}</option>
                                            
                                        </select>  
                                    </div>                                      
                                    <!-- BOTON REGISTRATE -->
                                    <v-layout justify-center >                        
                                        <v-btn  type="submit" depressed round color="#007bff" style="border:2px solid;border-radius: 10px 10px 10px 10px;width:90%;color:white">{{language==='English'?!isEdit?'CREATE PROJECT':'EDIT PROJECT':!isEdit?'CREAR PROYECTO':'EDITAR PROYECTO'}}</v-btn>                       
                                    </v-layout>
                                    <v-layout justify-center >                        
                                        <v-btn @click="modalcreateproject = false" depressed round color="secondary" style="color:white;border:2px solid;border-radius: 10px 10px 10px 10px;width:90%">{{language==='English'?'CLOSE':'CERRAR'}}</v-btn>                        
                                    </v-layout>
                                    <!-- TERMINO DE SERVICIO Y POLITICA DE PRIVACIDAD-->

                                </v-flex>
                            </v-layout>
                        </form>
                </v-container>
            </v-dialog>
        </v-layout>
        <v-layout justify-center style="margin-top:10px">
			<v-flex xs9 lg9>
				<select v-model="typeproject" class="form-control" @click="getallprojects">
						<option value="unselected" checked disabled>{{language === 'English'?'Choose the type of project or portfolio':'Elija el tipo de Proyecto o Portafolio'}}</option>
                        <option value="Todos">{{language ==='English'?'All':'Todos'}}</option>
                        <option value="Portafolio">{{language ==='English'?'Portfolio':'Portafolio'}}</option>
                        <option value="General">General</option>
				</select>
			</v-flex>
		</v-layout>
        <v-layout justify-center v-if="getdataprojects.length<=0">
			<label>{{language === 'English'?'No projects registered':'No hay proyectos registrados'}}</label>
		</v-layout>
        <v-layout justify-center style="margin-bottom:30px">
            <v-flex row lg6>
                <v-card v-for="getdataprojects in getdataprojects" :key="getdataprojects.length"
                    class="mx-auto"
                    max-width="344"
                    style="margin-top:20px;width:95%"
                >	
                    <div class="text-center">
                        <v-icon style="font-size:100px">fas fa-folder</v-icon>
                    </div>

                    <v-card-title>
                        <div class="w-100 text-center">
                            {{getdataprojects.name}}
                        </div>
                    </v-card-title>

                    <div>
                        <div class="text-center" style="width:99%">
                            <p align="justify" class="text-center">{{getdataprojects.description}}</p>
                        </div>
                    </div>
                    <div class="w-100" v-if="getdataprojects.visible==='public'">
                        <div class="text-center" v-if="false">	
                            <label>{{language==='English'?'It is on sale?':'¿Esta a la venta?'}}</label>
                            <label class="checkbox toggle switch text-center" @change="changeselloption(getdataprojects._id, getdataprojects.isselling)"  style="width: 100px;margin-left:36%">
                                <input id="view" v-model="getdataprojects.isselling" type="checkbox"  />
                                    <p>
                                        <span>{{language==='English'?'No':'No'}}</span>
                                        <span>{{language==='English'?'Yes':'Si'}}</span>
                                    </p>
                                    <a class="slide-button"></a>
                            </label>
                        </div>
                    </div>
                    <div class="w-100" v-if="false">
                        <div class="text-center">	
                            <label>{{language==='English'?`It´s a product?`:'¿Es un producto?'}}</label>
                            <label class="checkbox toggle switch text-center"   style="width: 100px;margin-left:36%">
                                <input id="view" v-model="getdataprojects.isproduct" type="checkbox" @change="changeproductoption(getdataprojects._id, getdataprojects.isproduct)" />
                                    <p>
                                        <span>{{language==='English'?'No':'No'}}</span>
                                        <span>{{language==='English'?'Yes':'Si'}}</span>
                                    </p>
                                    <a class="slide-button"></a>
                            </label>
                        </div>
                    </div>
                    <div class="text-left" style="margin-left:10px" v-if="false">
                        <label style="font-size:15px;font-weight:bold">$200</label>
                    </div>
                    <div class="text-right" style="margin-right:20px">
                        <label v-if="getdataprojects.punctuation === '1'">{{getdataprojects.punctuation}} <i class="fas fa-star"></i></label>
                        <label v-else>{{getdataprojects.punctuation}} <i class="fas fa-star"></i></label>
                    </div>
                    <v-card-actions>
                    <v-btn icon @click="deleteproject(getdataprojects._id)">
                        <v-icon>fas fa-trash</v-icon>
                    </v-btn>

                    <v-btn icon @click="checkfileproject(getdataprojects._id)">
                        <v-icon>fas fa-eye</v-icon>
                    </v-btn>
                    <v-btn icon @click="gocomments(getdataprojects._id)">
                        <v-icon>fas fa-comments</v-icon>
                    </v-btn>
                    <v-btn icon @click="getdatatoedit(getdataprojects)">
                        <v-icon>fas fa-edit</v-icon>
                    </v-btn>

                    <v-spacer></v-spacer>

            
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
const alertify = require('alertifyjs')
import { ProjectService } from "@/services";
import { EventBus } from '../../../../helpers/eventbus/event-bus';
import Projects from '../../../../models/projects';

export default {
    data(){
        return{
            test:null,
            language:'',
            typeproject:'Todos',
            isEdit:false,
            modalcreateproject:false,
            projects: new Projects(),
            getdataprojects:[],
            session:null,
            rules: {
                required: value => !!value || 'requerido.',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                //   emailMatch: () => ('The email and password you entered don\'t match'),
                    
                //   passwordvalidate: value => {
                //      const pattern = /^(?=.*\d)(?=.*[a-záéíóúüñ]).*[A-ZÁÉÍÓÚÜÑ]/
                //      return pattern.test(value) || 'Tu contraseña debe tener un carácter, una letra mayúscula, una minúscula y un número'
                //    },
                emailvalidate: value =>{
                    const pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
                    return pattern.test(value) || 'El email debe contener @ y otros carácteres mas'
                },
                passwordequal: value =>{
                    let passwordcondition = this.passwordmodel !== value
                    return !passwordcondition || 'La contraseña no concuerda con lo anterior escrito'
                },
            }
        }
    },
    sockets:{
        getpunctuation(data){
			if(this.session){
                let statevote = data
                if(statevote){
                    if(statevote.ok){
                        this.getallprojects()
                    }
                }
            }
		}
    },
    mounted(){
        this.session = JSON.parse(localStorage.getItem('user'))
        if(this.session){
            this.getallprojects()
        }else{
            this.$router.back()
        }
        EventBus.$on('changelanguage',()=>{
            let choosedlanguage = JSON.parse(localStorage.getItem('language'))
            this.language = choosedlanguage.language
            //console.log(this.language)
            //console.log(choosedlanguage)
        })
        let choosedlanguage = JSON.parse(localStorage.getItem('language'))
        if(choosedlanguage){
            this.language = choosedlanguage.language
        }
        
    },
    methods:{
        async changeproductoption(_id, isproduct){
            try{
                const data = {
                    isproduct:isproduct,
                    _id: _id
                }
                ProjectService.changeproductstatus(data)
            }catch(err){
                console.log(err)
            }
        },
        async changeselloption(_id, isselling){
            try{
                const data = {
                    isselling:isselling,
                    _id: _id
                }
                ProjectService.changesalesstatus(data)
            }catch(err){
                console.log(err)
            }
        },
        comadelete(){
            let caracter = this.projects.name.indexOf(",")
            if(caracter>=0){
                this.projects.name = ""
            }
            
        },
        openmodalproject(){
            this.projects = new Projects()
            this.modalcreateproject = true
        },
        getdatatoedit(project){
            this.isEdit = true
            this.projects = project
            this.modalcreateproject = true
        },
        gocomments(idproject){
            this.$router.push('/comments/'+idproject)
        },
        checkfileproject(idproject){
            this.$router.push('/projects/'+idproject)
        },
        deleteproject(idproject){
            let confirmcodition = confirm(this.language==='English'?'Do you want to delete this Project?':"¿Desea borrar este Proyecto?")
            if(confirmcodition){
                let query = {
                    idproject:idproject
                }
                ProjectService.deleteproject(query).then(res=>{
                    alertify.success(this.language ==='English'?'Project deleted':'Proyecto borrado')
                    this.getdataprojects = []
                    this.getallprojects()
                })
            }
        },
        getallprojects(){
            let id = JSON.parse(localStorage.getItem('iden'))._id
            let token = localStorage.getItem('tok')
            let query={
                typeproject:this.typeproject
            }
            ProjectService.getallprojects(query).then(res=>{
                if(res.data.projects.length>0){
                    res.data.projects.forEach(projects => {
                        let issellingundefined = projects.isselling ===undefined
                        let isproductundefined = projects.isproduct === undefined
                        if(issellingundefined){
                            projects.isselling = false
                        }
                        if(isproductundefined){
                            projects.isproduct = false
                        }
                    })
                    this.getdataprojects = res.data.projects
                    console.log(this.getdataprojects)
                }
            })
        },
        createproject(){
            if(this.projects.visible === 'selected'){
                alertify.error(this.language ==='English'?'Choose the privacy of your project':'Elija la privacidad de su proyecto')
            }else if(this.projects.type === 'unselected'){
                alertify.error(this.language ==='English'?'Choose the type of project or portfolio':'Elija el tipo de proyecto o portafolio')
            }else{
                if(!this.isEdit){
                    ProjectService.createproject(this.projects).then(res=>{
                        alertify.success(this.language ==='English'?'Project created':'Projecto creado')
                        this.projects = new Projects()
                        this.getallprojects()
                        let data = {
                            path : this.$route.name,
                            _id_user_sender: JSON.parse(localStorage.getItem('iden'))._id,
                            _id_project: res.data._id_project,
                            name_project : res.data.name_project
                        }
                        this.$socket.emit('save_notification',data)
                    })
                    .catch((err)=>{
                        let msg = err.response.data.message
                        if (msg === "Project exist") {
                            alertify.error(this.language?'There is a project with the same name':'Existe un Proyecto con ese mismo Nombre')
                        }else if(msg === "Superaste el limite gratuito que es 1 GB") {
                            alertify.error(this.language === 'English'?'You exceeded the free limit that is 1 GB':err.response.data.message)
                        }
                    })
                }else{
                    ProjectService.editproject(this.projects).then(res=>{
                        alertify.success(this.language ==='English'?'Project edited':'Projecto editado')
                        this.projects = new Projects()
                        this.isEdit = false
                        this.getallprojects()
                    })
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .switch .slide-button,
    .toggle p span {
        display: none;
    }
    .toggle {
        position: relative;
        padding: 0;
        
    }
    .toggle label {
        position: relative;
        z-index: 3;
        
        display: block;
        width: 100%;
    }
    .toggle input {
        position: absolute;
        opacity: 0;
        z-index: 5;
    }
    .toggle p {
        position: absolute;
        left: -100px;
        width: 100%;
        margin: 0;
        padding-right: 100px;
        text-align: left;
        font-family: OpenSans-SemiBold, "Helvetica Neue", helvetica, arial, sans-serif;
        font-size: .8em;
    }
    .toggle p span {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 5;
        display: block;
        width: 50%;
        margin-left: 100px;
        text-align: center;
    }
    .toggle p span:last-child {
        left: 50%;
    }
    .toggle .slide-button {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 4;
        display: block;
        width: 50%;
        height: 100%;
        padding: 0;
    }
    .toggle {
        display: block;
        height: 30px;
    }
    .toggle * {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -o-box-sizing: border-box;
        box-sizing: border-box;
    }
    .toggle .slide-button {
        display: block;
        
        -webkit-transition: all 0.3s ease-out;
        -moz-transition: all 0.3s ease-out;
        -ms-transition: all 0.3s ease-out;
        -o-transition: all 0.3s ease-out;
        transition: all 0.3s ease-out;
    }
    .toggle label,
    .toggle p {
        line-height: 30px;
        vertical-align: middle;
    }
    .toggle input:checked ~ .slide-button {
        right: 50%;
    }
    
    /* Bugfix for older Webkit, including mobile Webkit.
        * https://css-tricks.com/webkit-sibling-bug/
        */
    .switch, .toggle {
        -webkit-animation: bugfix infinite 1s;
    }
    @-webkit-keyframes bugfix { from { position: relative; } to { position: relative; } }
    .switch {
        background-color: #2aa0c8;
        color: #fff;
        font-weight: bold;
        text-align: center;
        text-shadow: 1px 1px 1px #191b1e;
        border-radius: 1px;
        padding: 2px 2px;
    }

    .switch input:checked + label {
        color: #333;
    }
        
    .switch .slide-button {
        border: 2px solid #D6D6D6;
        background-color: #D6D6D6;
        border-radius: 1px;
    }

    .switch p {
        color: #333;
        text-shadow: none;
    }

    .switch span {
        color: #fff;
    }

    .switch.blue .slide-button {
        background-color: #38a3d4;
    }

    .switch.yellow .slide-button {
        background-color: #f5e560;
    }

</style>